import { Dialog, DialogBody, DialogContent } from '@civilgrid/ui/components';
import type React from 'react';

interface MultipleAntennaLinkPopupProps {
  open: boolean;
  onClose: () => void;
  links: MultipleAntennaLink[];
}

export interface MultipleAntennaLink {
  url: string;
  owner: string;
  uniqueSystemIdentifier: string;
  callSign: string;
  locationNumber: string;
}

const MultipleAntennaLinkPopup: React.FC<MultipleAntennaLinkPopupProps> = ({ open, onClose, links }) => {
  return (
    <Dialog
      open={open}
      onOpenChange={(isOpen) => {
        if (!isOpen) onClose();
      }}
    >
      <DialogContent
        title="Multiple Antennae at this Location"
        className="z-[110] w-auto min-w-min max-w-[75vw]"
        overlayClassName="z-[100]"
        data-testid="multiple-antenna-links-dialog"
      >
        <DialogBody>
          <div className="min-w-[40rem] p-4">
            <table className="w-full border-collapse">
              <thead>
                <tr className="border-b text-left">
                  <th className="p-2 text-xs font-medium">Owner</th>
                  <th className="p-2 text-xs font-medium">Call Sign</th>
                  <th className="p-2 text-xs font-medium">System ID</th>
                  <th className="p-2 text-xs font-medium">Location #</th>
                </tr>
              </thead>
              <tbody>
                {links.map((location) => (
                  <tr key={location.uniqueSystemIdentifier} className="border-b">
                    <td className="p-2">
                      <a
                        href={location.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-blue-50 underline hover:text-blue-60"
                      >
                        {location.owner}
                      </a>
                    </td>
                    <td className="p-2 text-xs">{location.callSign}</td>
                    <td className="p-2 text-xs">{location.uniqueSystemIdentifier}</td>
                    <td className="p-2 text-xs">{location.locationNumber}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </DialogBody>
      </DialogContent>
    </Dialog>
  );
};

export default MultipleAntennaLinkPopup;
